const isLocal = process.env.REACT_APP_ENV === 'local';

export const isStartDomain = () => {
  console.log('isStartDomain called, isLocal:', isLocal);
  if (isLocal) {
    console.log('Returning true for local environment');
    return false;
  }

  const domainName = window.location.hostname;
  console.log('domainName', domainName);

  const isStart =
    domainName === 'start.circlessandiego.org' ||
    domainName === 'dev.start.circlessandiego.org' ||
    domainName === 'pre.start.circlessandiego.org';
  console.log('isStartDomain result:', isStart);
  console.log('Checking domain match:');
  console.log(
    'domainName === "start.circlessandiego.org":',
    domainName === 'start.circlessandiego.org'
  );
  console.log(
    'domainName === "dev.start.circlessandiego.org":',
    domainName === 'dev.start.circlessandiego.org'
  );
  console.log(
    'domainName === "pre.start.circlessandiego.org":',
    domainName === 'pre.start.circlessandiego.org'
  );

  return isStart;
};

export const isHelpDomain = () => {
  console.log('isHelpDomain called, isLocal:', isLocal);
  // For local environment, let's use start domain only to avoid conflicts
  if (isLocal) {
    console.log('Returning false for local environment (using start domain)');
    return true;
  }

  const domainName = window.location.hostname;
  console.log('isHelpDomain - domainName', domainName);

  const isHelp =
    domainName === 'help.circlessandiego.org' ||
    domainName === 'dev.help.circlessandiego.org' ||
    domainName === 'pre.help.circlessandiego.org';
  console.log('isHelpDomain result:', isHelp);

  return isHelp;
};
